<template>
  <div class="brand-plank">
    <div class="top-operation">
      <div class="top-operation-left">
        <div class="standard-slab-title">
          <div class="bluelable"></div>
          <span class="small-title ellipsis">{{
            $t('basePlankManager.brandPlank')
          }}</span>
          <span
            class="small-title ellipsis"
            style="margin-left: 10px; color: rgba(0, 0, 0, 0.25)"
            >{{
              $translateLang(
                '注：品牌大板删除与修改在柜柜客户端板材资源库进行操作'
              )
            }}</span
          >
        </div>
      </div>
      <div class="top-operation-right">
        <el-select
          v-model="filterBrand"
          filterable
          clearable
          size="small"
          style="width: 140px; margin-right: 8px"
          :placeholder="$t('basePlankManager.brandPlaceholder')"
          id="base_material_brandPlank_filter_brand_select"
        >
          <el-option
            v-for="(item, index) in brandOptions"
            :key="index"
            :value="item"
            :label="item"
            :id="`base_material_brandPlank_filter_brand_option_${index}`"
          ></el-option>
        </el-select>
        <el-select
          v-model="filterSupplier"
          filterable
          clearable
          size="small"
          style="width: 140px; margin-right: 8px"
          :placeholder="$t('basePlankManager.supplierPlaceholder')"
          id="base_material_brandPlank_filter_supplier_select"
        >
          <el-option
            v-for="(item, index) in supplierOptions"
            :key="index"
            :value="item"
            :label="item"
            :id="`base_material_brandPlank_filter_supplier_option_${index}`"
          ></el-option>
        </el-select>
        <a-input-search
          v-model="searchVal"
          :placeholder="$t('basePlankManager.searchBrandPlaceholder')"
          style="width: 300px"
          id="base_material_brandPlank_searchPlank_input"
        >
          <template #enterButton>
            <a-icon
              type="search"
              id="base_material_brandPlank_searchPlank_icon_btn"
            />
          </template>
        </a-input-search>
      </div>
    </div>
    <div class="brand-slab-list">
      <el-table
        :data="filterBrandSlabList"
        border
        :header-cell-style="{ backgroundColor: '#f5f5f5' }"
        :header-cell-class-name="({ column }) => column.property"
        row-key="rowId"
        default-expand-all
        :tree-props="{ children: 'children', hasChildren: 'hasChildren' }"
        :empty-text="$t('basePlankManager.brandPlank')"
      >
        <el-table-column
          prop="brand_name"
          :label="$t('basePlankManager.brand')"
          width="120"
        >
          <template slot-scope="scope">
            <div>{{ scope.row.brand_name || '-' }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="supplier_name"
          :label="$t('basePlankManager.supplier')"
          width="120"
        >
          <template slot-scope="scope">
            <div>{{ scope.row.supplier_name || '-' }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="matCode"
          :label="$t('common.plankMatCode')"
          width="140"
        >
          <template slot-scope="scope">
            <div>{{ scope.row.children ? '-' : scope.row.matCode }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="color"
          :label="$t('common.plankColor')"
          width="140"
        >
          <template slot-scope="scope">
            <div>{{ scope.row.children ? '-' : scope.row.color }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="thick" :label="`${$t('common.plankThick')}(mm)`">
          <template slot-scope="scope">
            <div>{{ scope.row.children ? '-' : scope.row.thick }}</div>
          </template>
        </el-table-column>
        <el-table-column prop="width" :label="`${$t('common.plankWidth')}(mm)`">
          <template slot-scope="scope">
            <div>{{ scope.row.children ? '-' : scope.row.width }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="height"
          :label="`${$t('common.plankHeight')}(mm)`"
        >
          <template slot-scope="scope">
            <div>{{ scope.row.children ? '-' : scope.row.height }}</div>
          </template>
        </el-table-column>
        <el-table-column
          prop="trim_edge"
          :label="$t('basePlankManager.offsetSize')"
        >
          <template slot-scope="scope">
            <div>
              {{
                scope.row.children
                  ? '-'
                  : handleShowTrimEdge(scope.row.trim_edge)
              }}
            </div>
          </template>
        </el-table-column>
        <el-table-column :label="$t('common.operation')" width="100">
          <template slot-scope="scope">
            <a-button
              v-if="!scope.row.children && !scope.row.plateId"
              type="link"
              size="small"
              @click="$emit('editBrandPlank', scope.row)"
            >
              {{ $t('common.edit') }}
            </a-button>
            <span v-else>-</span>
          </template>
        </el-table-column>
        <el-table-column
          prop="is_high_gloss_plank"
          :label="$t('common.heighGlossPlank')"
        >
          <template #header>
            <div class="flex flex-main--justify flex-cross--center">
              <span>{{ $t('common.heighGlossPlank') }}</span>
            </div>
          </template>
          <template slot-scope="scope">
            <div v-if="!scope.row.children">
              {{
                scope.row.is_high_gloss_plank
                  ? matchHighlightBoardName(scope.row.matCode)
                  : `非${matchHighlightBoardName(scope.row.matCode)}`
              }}
            </div>
            <div v-else>-</div>
          </template>
        </el-table-column>
      </el-table>
    </div>
  </div>
</template>

<script>
import { matchHighlightBoardName } from '@/util/commonFun'

export default {
  props: {
    brandPlankList: {
      type: Array,
      default: () => [],
    },
  },
  data() {
    return {
      searchVal: '',
      filterBrand: '',
      filterSupplier: '',
      baseList: [],
      slabList: [],
    }
  },
  computed: {
    brandOptions() {
      const brands = new Set()
      this.brandPlankList.forEach((item) => {
        if (item.brand_name) brands.add(item.brand_name)
      })
      return Array.from(brands)
    },
    supplierOptions() {
      const suppliers = new Set()
      let list = this.brandPlankList
      if (this.filterBrand) {
        list = list.filter((item) => item.brand_name === this.filterBrand)
      }
      list.forEach((item) => {
        if (item.supplier_name) suppliers.add(item.supplier_name)
      })
      return Array.from(suppliers)
    },
    filterBrandSlabList() {
      let list = this.slabList
      if (this.filterBrand) {
        list = list.filter((item) => item.brand_name === this.filterBrand)
      }
      if (this.filterSupplier) {
        list = list.filter((item) => {
          if (item.children) {
            return item.children.some(
              (child) => child.supplier_name === this.filterSupplier
            )
          }
          return item.supplier_name === this.filterSupplier
        })
      }
      if (this.searchVal) {
        list = list.filter(
          (item) =>
            item.brand_name?.includes(this.searchVal) ||
            item.supplier_name?.includes(this.searchVal) ||
            item.matCode?.includes(this.searchVal) ||
            item.color?.includes(this.searchVal) ||
            (item.children &&
              item.children.some(
                (child) =>
                  child.matCode?.includes(this.searchVal) ||
                  child.color?.includes(this.searchVal) ||
                  child.brand_name?.includes(this.searchVal) ||
                  child.supplier_name?.includes(this.searchVal)
              ))
        )
      }
      return list.map((item) => ({
        ...item,
        sourceMatCode: item.matCode,
        matCode: item.matCode?.replace(/高光_/g, '') || '',
        children: item.children?.map((it) => ({
          ...it,
          sourceMatCode: it.matCode,
          matCode: it.matCode?.replace(/高光_/g, '') || '',
        })),
      }))
    },
  },
  watch: {
    brandPlankList: {
      handler(val) {
        this.baseList = JSON.parse(JSON.stringify(val))
        this.handleBrandSlabListData(this.baseList)
      },
      immediate: true,
    },
  },
  methods: {
    matchHighlightBoardName(matcode) {
      return matchHighlightBoardName(matcode)
    },
    handleBrandSlabListData(arr) {
      let newArr = []
      if (!arr.length) {
        this.slabList = newArr
        return
      }
      let id = -1
      const brandSupplierMap = new Map()
      arr.forEach((item) => {
        const brandKey = item.brand_name || ''
        const supplierKey = item.supplier_name || ''
        const groupKey = `${brandKey}_${supplierKey}`
        if (!brandSupplierMap.has(groupKey)) {
          brandSupplierMap.set(groupKey, {
            brand_name: brandKey,
            supplier_name: supplierKey,
            children: [],
          })
        }
        brandSupplierMap.get(groupKey).children.push({ ...item })
      })

      brandSupplierMap.forEach((group) => {
        if (group.children.length > 1) {
          newArr.push({
            ...group,
            matCode: group.children[0]?.matCode || '',
            color: group.children[0]?.color || '',
            thick: group.children[0]?.thick || '',
            rowId: id--,
          })
        } else {
          newArr.push(group.children[0])
        }
      })
      this.slabList = newArr
    },
    handleShowTrimEdge(trimEdge) {
      if (trimEdge && trimEdge.toString().includes(',')) {
        const trimEdgeArr = trimEdge.split(',')
        return (
          this.$t('basePlankManager.front') +
          trimEdgeArr[0] +
          '-' +
          this.$t('basePlankManager.back') +
          trimEdgeArr[1] +
          '-' +
          this.$t('basePlankManager.left') +
          trimEdgeArr[2] +
          '-' +
          this.$t('basePlankManager.right') +
          trimEdgeArr[3]
        )
      } else {
        return trimEdge || ''
      }
    },
  },
}
</script>

<style lang="less" scoped>
.brand-plank {
  .small-title {
    color: #333;
    font-weight: 500;
    font-size: 14px;
    font-family: PingFangSC-Medium, 'PingFang SC';
    line-height: 52px;
  }

  .top-operation {
    display: flex;
    align-items: center;
    justify-content: space-between;
    background: #fff;

    .top-operation-left {
      .standard-slab-title {
        display: flex;
        .bluelable {
          width: 4px;
          height: 14px;
          margin: 19px 16px;
          background: #18a8c7;
          border-radius: 1px;
        }
      }
    }

    .top-operation-right {
      display: flex;
      align-items: center;
      margin-right: 16px;
    }
  }

  .brand-slab-list {
    /deep/ .el-table {
      .is_high_gloss_plank .cell {
        overflow: visible;
      }

      .el-table__row--level-0 td:first-child .cell {
        display: flex;
        align-items: center;
        padding-left: 8px;

        .el-table__indent,
        .el-table__placeholder {
          display: none;
        }

        .el-table__expand-icon {
          margin-right: 6px;
        }
      }
    }
  }
}
</style>
